import moment from "moment";
import SignalContent from "../signal_content";
import { SignallampSensorData } from "../../../types/types";
import { translate } from "@/main";

export function makeSensorData(self: SignalContent, sensorData: SignallampSensorData) {
  const newSensorData = makeTimeData(sensorData, self.timeZone);
  return newSensorData;
}

function makeTimeData(
  sensorData: SignallampSensorData,
  timeZone: string,
) {
  if (sensorData) {
    sensorData.time_stamp =
    moment(sensorData.time_stamp)
      .utcOffset(timeZone)
      .format("YYYY-MM-DD HH:mm:ss");
    return sensorData.time_stamp;
  }
  return `${translate("message.notAcquired")}`;
}
